import React from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../Context/LanguageContext';
import './CustomPopup.css';

const CustomPopup = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  type = 'info',
  confirmText,
  cancelText,
  showCancel = false,
  confirmButtonClass = null,
  confirmButtonStyle = null,
  titleStyle = null,
  loading = false,
}) => {
  const { t } = useLanguage();

  // Use default translations if not provided
  const finalConfirmText = confirmText || t('components.custompopup.ok');
  const finalCancelText = cancelText || t('components.custompopup.cancel');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  // Use React Portal to render at document body level
  return ReactDOM.createPortal(
    <div className="custom-popup-overlay" onClick={handleCancel}>
      <div className={`custom-popup custom-popup-${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="custom-popup-header">
          <h3 style={titleStyle}>{title}</h3>
        </div>

        <div className="custom-popup-body">
          {typeof message === 'string' ? (
            <p>{message}</p>
          ) : (
            message
          )}
        </div>

        <div className="custom-popup-footer">
          {showCancel && (
            <button
              className="custom-popup-btn custom-popup-btn-cancel"
              onClick={handleCancel}
            >
              {finalCancelText}
            </button>
          )}
          <button
            className={`custom-popup-btn ${confirmButtonClass || `custom-popup-btn-${type === 'confirm' ? 'danger' : 'primary'}`}`}
            style={confirmButtonStyle}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? '...' : finalConfirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CustomPopup;